import { useTextePublic } from '../../lib/textes-publics'
import { TEXTES_BONS_PUBLICS as messages } from '@tb/shared'

export type CleBons = keyof typeof messages
export function useTextesBons() {
  const langue = useTextePublic().langue
  return (cle: CleBons) => (langue === 'fr' ? cle : messages[cle][langue])
}
